import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { FilterOptionType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { IFilterOption } from 'src/app/library/interfaces/filters/filter-option';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-multi-select-search',
    templateUrl: './filter-multi-select-search.component.html',
    styleUrls: ['./filter-multi-select-search.component.scss']
})
export class FilterMultiSelectSearchComponent implements OnInit {
    @Input() filter: IFilter;

    public search = new UntypedFormControl();

    private _data = new BehaviorSubject<IFilterOption[]>(undefined);
    public data$: Observable<IFilterOption[]> = this._data.asObservable();

    public dataTypeEnum = FilterOptionType;
    public dataLoading: boolean = false;

    constructor(private filterService: FilterService) {}

    ngOnInit() {
        this.listeners();
    }

    public removeFilter() {
        this.filterService.removeFilter(this.filter);
        this.filterService.filterChangeEvent();
    }

    public selectOption(obj: IFilterOption, filter: IFilter) {
        let currentVal = this.filterService.filterConfig;
        let filterVal: IFilter = filter;

        if (!filter.isQueryable) {
            filterVal = currentVal.filters.find(
                e => e.field == this.filter.field
            );
        }

        if (filterVal) {
            let optionVal = filterVal.options?.find(e => e.value == obj.value);
            if (optionVal) {
                optionVal.isSelected = !optionVal.isSelected;
            } else {
                obj.isSelected = !obj.isSelected;
                filterVal.options = [...(filterVal.options ?? []), obj];
            }
            this.filterService.filterConfig = currentVal;
            this.filterService.filterChangeEvent();
            this._data.next(filterVal.options);
        }
    }

    public onFilterClick() {
        this.search.setValue('', { emitEvent: false });
    }

    private listeners() {
        this.search.valueChanges
            .pipe(
                debounceTime(200),
                filter(x => x)
            )
            .subscribe(async (data: string) => {
                this.dataLoading = true;
                if (this.filter.isQueryable) {
                    const respOptions: IFilterOption[] =
                        await this.filterService.filterQueryEvent(
                            this.filter,
                            data
                        );

                    this._data.next(respOptions);
                } else {
                    data = data.toLowerCase();
                    this._data.next(
                        this.filter.options.filter(
                            x =>
                                x.heading?.toLowerCase().includes(data) ||
                                x.subheading?.toLowerCase().includes(data)
                        )
                    );
                }
                this.dataLoading = false;
            });
    }

    get selectedOptions() {
        return this.filter.options?.filter(e => e.isSelected);
    }

    get isMostRecentFilter() {
        return (
            this.filterService.mostRecentFilter()?.field == this.filter.field
        );
    }

    get addedFilterLength() {
        return this.filterService.filterConfig.filters.filter(e => e.added)
            .length;
    }
}
